export const defaultState = {
  programs: [],
  subPrograms: [],
  topics: [],
  organizationTypes: [],
  trainingProviders: [],
  traingProviderAttachmentTypes: [],
  venues: [],
  trainings: [],

  providerPrograms: [],
  traineeCategories: [],

  trainerCategories: [],

  trainers: [],

  programCategories: [],
  traineeSubCategories: [],

  membershipRequests: [],

  countries: [],

  venueTypes: [],
};
